import { Component, inject } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { CobaltSpinnerModule } from '@msi/cobalt-prime';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';

export interface LoadingDialogData {
  title?: string;
  message?: string;
}

@Component({
  selector: 'app-loading-dialog',
  standalone: true,
  imports: [TranslocoDirective, CobaltSpinnerModule],
  templateUrl: './loading-dialog.component.html',
  styleUrls: ['./loading-dialog.component.scss'],
})
export class LoadingDialogComponent {
  private readonly config = inject<DynamicDialogConfig<LoadingDialogData>>(DynamicDialogConfig);
  public readonly title: string | undefined = this.config.data?.title;
  public readonly message: string | undefined = this.config.data?.message;
}
